import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Booking } from 'components/EventCalendar/types';
import { PaymentStatusBadge } from 'components/MollieConnect/PaymentStatusBadge';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { PriceComponent } from './PriceComponent';

interface Props {
    booking: Booking;
    onEditPrice: (booking: Booking) => void;
}

/** Money column: the amount on the right edge with the edit affordance, the payment and invoice
 * state muted underneath. An online payment locks the price, so the pencil only shows without one. */
export const PaymentComponent = ({ booking, onEditPrice }: Props) => {
    const { t } = useTranslation('bookings');

    const invoicedAt = booking.last_invoice_created_at
        ? t('booking.list.payment.invoicedAt', {
              date: moment(booking.last_invoice_created_at).format('DD.MM.YY')
          })
        : booking.payment_id
          ? null
          : t('booking.list.payment.notInvoiced');

    return (
        <div className="tw-flex tw-flex-col tw-items-end tw-gap-1">
            {booking.payment_id ? (
                <PriceComponent booking={booking} />
            ) : (
                <button
                    type="button"
                    title={t('booking.list.modals.updatePrice.title')}
                    className="tw-m-0 tw-inline-flex tw-cursor-pointer tw-items-center tw-border-none tw-bg-transparent tw-p-0 tw-font-[inherit] hover:tw-opacity-70"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onEditPrice(booking);
                    }}
                >
                    <PriceComponent booking={booking}>
                        <FontAwesomeIcon icon={faEdit} size="xs" className="tw-block tw-text-accents-6" />
                    </PriceComponent>
                </button>
            )}
            <div className="tw-flex tw-max-w-full tw-items-center tw-justify-end tw-gap-1.5">
                {booking.payment_id && (
                    <PaymentStatusBadge flat size="xs" status={booking.payment_status} paymentId={booking.payment_id} />
                )}
                {invoicedAt && (
                    <span className="tw-truncate tw-text-xs tw-leading-4 tw-text-accents-6" title={invoicedAt}>
                        {invoicedAt}
                    </span>
                )}
            </div>
        </div>
    );
};
